var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logoBox"},[(_vm.entityLogo)?_c('el-image',{staticStyle:{"width":"100px","height":"100px"},attrs:{"src":_vm.getUrl(_vm.entityLogo),"fit":"fill"}}):_vm._e(),_c('span',{staticStyle:{"font-size":"16px","color":"#3590f8"}},[_vm._v(" "+_vm._s(_vm.entityName)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }